import { Modal } from 'react-bootstrap';
import React from 'react';
import mokaLogo from './images/moka-logo-with-tagline.png';
import styles from './WelcomeModal.css';

function WelcomeModal(props) {
  const { isShowing, onKeepInMobileSite, onViewFullSite } = props;

  return (
    <Modal show={isShowing} dialogClassName={styles.dialog}>
      <Modal.Body className={styles.body}>
        <div className={styles.imageContainer}>
          <img src={mokaLogo} className={styles.logo} />
        </div>

        <h4 className={styles.title}>Welcome to Moka Backoffice</h4>

        <p className={styles.description}>
          You are in Mobile Site view. Explore our full set of features by
          viewing in Full Site.
        </p>

        <button
          className={`btn btn-default ${styles.keepInMobileButton}`}
          onClick={onKeepInMobileSite}
        >
          Keep viewing in Mobile Site
        </button>

        <button
          className={`btn btn-primary ${styles.viewFullSiteButton}`}
          onClick={onViewFullSite}
        >
          View Full Site
        </button>
      </Modal.Body>
    </Modal>
  );
}

WelcomeModal.defaultProps = {
  isShowing: false,
  onKeepInMobileSite: () => {},
  onViewFullSite: () => {},
};

export default WelcomeModal;
